import { AuthConfig } from "@nutrien/axp-orchestrator-module/build/interfaces";
import { AuthStorage } from "../helpers/authStorage";

const env = process.env.REACT_APP_ENV;

const config: AuthConfig = {
  awsRegion: "ap-southeast-2",
  cognitoRegion: "ap-southeast-2",
  userPoolWebClientId: "4aj3c9mcrj6t7jnorcstn79esh",
  storage: AuthStorage,
  type: env,
  appUserGroupName: "",
  appClientId: "4aj3c9mcrj6t7jnorcstn79esh",
  domain: "dev-axp-nutrien.auth.ap-southeast-2.amazoncognito.com",
  scope: ["phone", "email", "profile", "openid", "aws.cognito.signin.user.admin"],
  redirectSignIn: `${location.protocol}//${location.host}/login/redirect`,
  redirectSignOut: `${location.protocol}//${location.host}/logout`,
  userPoolId: "ap-southeast-2_L0k9eDzbf",
  loglevel: "DEBUG",
  cookieExpiration: 7
};

if (env === "staging") {
  config.userPoolWebClientId = "1gtbqbn6ab018scevnhsd7ril6";
  config.appClientId = "1gtbqbn6ab018scevnhsd7ril6";
  config.domain = "stage-axp-nutrien.auth.ap-southeast-2.amazoncognito.com";
  config.userPoolId = "ap-southeast-2_APzPrV7tU";
}

const ppEnvironments: (string | undefined)[] = ["uat", "uat-blue", "uat-green", "pp", "train"];

if (ppEnvironments.includes(env)) {
  config.userPoolWebClientId = "3cq9uti8n6cglu3423rhodjr6p";
  config.appClientId = "3cq9uti8n6cglu3423rhodjr6p";
  config.domain = "preprod-axp-nutrien.auth.ap-southeast-2.amazoncognito.com";
  config.userPoolId = "ap-southeast-2_eca6qSOxZ";
}

const productionEnvironments: (string | undefined)[] = ["prod", "prod-blue", "prod-green"];

if (productionEnvironments.includes(env)) {
  config.userPoolWebClientId = "2vbr77tggdg8ro64esi6omo8km";
  config.appClientId = "2vbr77tggdg8ro64esi6omo8km";
  config.domain = "axp-nutrien.auth.ap-southeast-2.amazoncognito.com";
  config.userPoolId = "ap-southeast-2_O4eGfnzaQ";
}

export default config;
